import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import { useCallback, useMemo, useState } from 'react';
import { makeQueryParams } from '../../Search/TableView/utils/makeSearchQueryParams';
import { uniq } from 'underscore';
import { hasResolved } from '@cube3/state/src/redux/ducks/request-status/utils/hasResolved';
import { SearchResult2 } from '@cube3/common/model/schema/resources/search-result-2';

export const useImageSearchResult = (query: string, pageSize = 15) => {
  const [pages, setPages] = useState([1]);
  const loadMore = useCallback(() => {
    setPages([...pages, pages.length + 1]);
  }, [pages, setPages]);

  const [workspaceId] = useCurrentWorkspace();
  const {
    resources: results,
    loading,
    status,
    pageCounts
  } = useResourceList__ALPHA(
    useMemo(() => {
      const queryParams = makeQueryParams({
        display_name: query,
        searchBy: 'all',
        type: 'image'
      });
      return {
        resourceType: query ? 'workspace' : undefined,
        resourceId: query ? workspaceId : undefined,
        edgeType: query ? 'search-result-2' : undefined,
        edgeLabel: `search`,
        params: {
          ...queryParams,
          search: { query: query },
          page: { size: pageSize }
        },
        pages,
        strategy: 'fetch-on-mount'
      };
    }, [workspaceId, pages, pageSize, query])
  );

  const canLoadMore =
    !loading && pageCounts && pages.length < pageCounts.pageCount;

  const deduped = useMemo(() => {
    return uniq(results) as SearchResult2[];
  }, [results]);

  return useMemo(() => {
    return {
      results: deduped,
      loading: loading || (status && !hasResolved(status)),
      canLoadMore,
      loadMore
    };
  }, [deduped, status, loading, canLoadMore, loadMore]);
};
